import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  requestDashboard,
  requestElectricity,
  requestHashRate,
  requestMiningTotal,
} from 'store/api/cuverse-api/dashboard/dashboard.service';
import { DashboardElectricityResponseSchema } from 'store/api/cuverse-api/dashboard/types/dashboard-electricity-response';
import { DashboardHashRateResponseSchema } from 'store/api/cuverse-api/dashboard/types/dashboard-hashrate-response';
import { DashboardMiningTotalResponseSchema } from 'store/api/cuverse-api/dashboard/types/dashboard-mining-response';
import { WalletDataResponseSchema } from 'store/api/cuverse-api/dashboard/types/dashboard-wallet-response';

import { requestWithZodSchema } from 'utils/common/requestWithZodSchema';

export const requestDashboardWalletBalance = createAsyncThunk('dashboard/wallet', async () => {
  const { btcBalance } = await requestWithZodSchema(requestDashboard, WalletDataResponseSchema);
  return btcBalance;
});

export const requestDashboardElectricity = createAsyncThunk('dashboard/electricity', async () => {
  return await requestWithZodSchema(requestElectricity, DashboardElectricityResponseSchema);
});

export const requestDashboardMiningHashRate = createAsyncThunk(
  'dashboard/mining/hashrate',
  async () => {
    return await requestWithZodSchema(requestHashRate, DashboardHashRateResponseSchema);
  },
);

export const requestDashboardMiningTotal = createAsyncThunk('dashboard/mining/total', async () => {
  return await requestWithZodSchema(requestMiningTotal, DashboardMiningTotalResponseSchema);
});
